<template>
	<div>
		<b-container>
			<b-row>
				<b-col cols="5">
					<b-btn v-b-toggle="'basic_info'" block>Basic Info</b-btn>
					<b-collapse id="basic_info">
						<b-card>
							<basic-info update_button :active_syllabus="active_syllabus"/>
						</b-card>
					</b-collapse>

					<b-container>
						<b-row>
							<b-col>
								
							</b-col>
						</b-row>
					</b-container>

					<b-btn style="margin-top: 10px;" v-b-toggle="'sections'" block>Content</b-btn>
					<b-collapse id="sections">
						<b-card>
							<div v-if="active_syllabus.sections.length == 0">
								You don't have any sections yet.  Click below to add one!
							</div>
							<div v-else>
								<div v-for="(section, ind) in active_syllabus.sections" :key="ind" style="margin-top: 10px;">
									<b-container fluid>
										<b-row>
											<b-col>
												<b-btn v-b-toggle="`section_${ind}`" block>{{section.title != '' ? section.title : '[No Title]'}}</b-btn>
											</b-col>
											<b-col cols="5">
												<b-btn 
													@click="[active_syllabus.sections[ind], active_syllabus.sections[ind - 1]] = [active_syllabus.sections[ind - 1], active_syllabus.sections[ind]]; recompute_int = (recompute_int + 1) % 10"
													variant="secondary" :disabled="ind == 0">/\</b-btn>
												<b-btn
													@click="[active_syllabus.sections[ind], active_syllabus.sections[ind + 1]] = [active_syllabus.sections[ind + 1], active_syllabus.sections[ind]]; recompute_int = (recompute_int + 1) % 10"
													variant="secondary"
													:disabled="ind == active_syllabus.sections.length - 1">\/</b-btn>
												<b-btn @click="active_syllabus.sections.splice(ind, 1)" variant="danger">X</b-btn>
											</b-col>
										</b-row>
									</b-container>
									<b-collapse :id="`section_${ind}`">
										<b-card>
											<b-select v-model="section.type" :options="[{value: 'text', text: 'Text'}, {value: 'schedule', text: 'Course Schedule'}]"/>
											<b-input placeholder="Header (optional)" v-model="section.title"/>
											<div v-if="section.type == 'text'">
												<b-textarea placeholder="Text" v-model="section.text"/>
											</div>
										</b-card>
									</b-collapse>
								</div>
							</div>
							<b-btn @click="active_syllabus.sections.push({title: 'New Section', text: '', type: 'text'})" style="margin-top: 10px;" variant="info" block>Add Content</b-btn>
						</b-card>
					</b-collapse>

					<b-btn style="margin-top: 10px;" v-b-toggle="'day_plans'" block>Day Plans</b-btn>
					<b-collapse id="day_plans">
						<b-card>
							<b-card :header="new Date(day.date).toDateString()" v-for="(day, ind) in active_syllabus.class_day_data" :key="ind" style="margin-bottom: 10px;">
								<b-textarea placeholder="Enter day text here" v-model="day.data.text"/>
							</b-card>
						</b-card>
					</b-collapse>
					
					<div style="margin-bottom: 45px;"/>
					<b-btn style="position: absolute; bottom: 0px;" block variant="primary" @click="save">Save Changes</b-btn>
				</b-col>
				<b-col class="pdf-preview-container">
					<div class="pdf-container">
						<div ref="pdf_preview" id="pdf_preview">
							<iframe ref="pdf_scroll" style="width: 100%; height: 100%;" :src="`data:text/html;charset=utf-8,<style>body{margin: 1in; font-size: 12pt;}</style>${srcHTML}`"/>
							<!--
							<object type="text/html" ref="pdf_scroll" style="width: 100%; height: 100%;" :src="`data:text/html;charset=utf-8,<style>body{margin: 1in;}</style>${srcHTML}`">
								<p>Your browser does not support live previewing of this 
							</object>
							-->
						</div>
					</div>
					<div style="width: 100%;">
						<p style="text-align: center;margin-top: 10px;">Note: Formatting, especially size, may be slightly different in Word document.</p>
						<b-container>
							<b-row>
								<b-col>
									<b-btn @click="downloadSyl" style="display: block;; margin: auto;" variant="primary">Export Syllabus Data</b-btn>
								</b-col>
								<b-col>
									<b-btn @click="downloadDocx" style="display: block;; margin: auto;" variant="primary">Export .docx</b-btn>
								</b-col>
							</b-row>
						</b-container>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import BasicInfo from './BasicInfo.vue'
import htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver'

function processInputString(str)
{
	return str.trim().replaceAll(/(<(\/*)(b|i|span)>)\n/, '$1 \n').replaceAll(/(<(\/*)(([A-Za-z]+)>))\n/, '$1').replaceAll('\n', '<br/>')
}

export default {
	components: {
		BasicInfo
	},
	props: {
		active_syllabus : Object,
		load_syllabus_data : Function
	},
	watch: {
		["$route"](){
			this.load();
		},
		srcHTML(){
			this.updatePreview();
		}
	},
	data(){
		return {
			recompute_int: 0
		}
	},
	computed: {
		srcHTML(){
			if (this.recompute_int == NaN)
			{
				console.error('Numberic precision has failed.  How long have you been on this page?');
			}
			let html = '<html>'
				html += '<head>'
				html += '<style>ul{display: block; list-style-type: disc; margin-top: 1em; margin-bottom: 1 em; margin-left: 0; margin-right: 0; padding-left: 40px;}li{display: list-item;}</style>'
				html += '</head>'
				html += '<body>'
					html += `<h1>${this.active_syllabus.course_number}: ${this.active_syllabus.course_title}</h1>`;
					html += `<div style="font-weight: bold;">`
						html += "<p>"
							html += `Instructor: ${this.active_syllabus.course_instructor}<br/>`;
							if (this.active_syllabus.course_tas.length > 0)
							{
								if (this.active_syllabus.course_tas.includes(','))
								{
									html += `Teaching Assistants: ${this.active_syllabus.course_tas}<br/>`;
								}
								else
								{
									html += `Teaching Assistant: ${this.active_syllabus.course_tas}<br/>`;
								}
							}
							html += `Location: ${this.active_syllabus.course_location}<br/>`;
							html += `Meeting Times: ${this.active_syllabus.start_time}-${this.active_syllabus.end_time}<br/>`;
							html += `Meeting Days: `;
							{
								let dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
								let generated = false;
								for (var i = 0; i < this.active_syllabus.class_days.length; ++i)
								{
									if (this.active_syllabus.class_days[i])
									{
										if (generated)
										{
											html += ", ";
										}
										html += dayNames[i];
										generated=true;
									}
								}
							}
							html += "<br/>"
						html += "</p>"
					html += `</div>`

					// Description section
					for(let i = 0; i < this.active_syllabus.sections.length; ++i)
					{
						let section = this.active_syllabus.sections[i];
						if (section.title != '')
						{
							html += `<h2>${section.title}</h2>`
						}
						switch(section.type)
						{
							case 'schedule':
							{
								let lastPrintedWeek = 0;
								let curWeek = 1;
								let startDay = -1;
								for (let i = 0; i < this.active_syllabus.class_days.length; ++i)
								{
									if (this.active_syllabus.class_days[i])
									{
										startDay = i;
										break;
									}
								}

								for (let i = 0; i < this.active_syllabus.class_day_data.length; ++i)
								{
									let data = this.active_syllabus.class_day_data[i];
									let date = new Date(data.date);
									
									if (i > 0 && date.getDay() - 1 == startDay)
									{
										++curWeek;
									}
									
									html += `<h3>${date.toDateString()}`
									if (lastPrintedWeek != curWeek)
									{
										html += ` (Week ${curWeek})`
										lastPrintedWeek = curWeek;
									}
									html += '</h3>'
									html += `<p>${processInputString((data.data.text == undefined || data.data.text == null || data.data.text == '' ? '[Insert text in the Day Planner]' : data.data.text))}</p>`
								}
								if (this.active_syllabus.has_final)
								{
									let date = new Date(this.active_syllabus.final_date);
									html += `<h3>${date.toDateString()}`
									html += '</h3>'
									html += `<p><b>Final Exam</b></p>`
								}
								break;
							}
							default:
								html += `<p>${processInputString(section.text)}</p>`
								break;
						}
					}

					
				html += '</body>'
			html += '</html>'

			return html;
		}
	},
	methods: {
		load(){
			let file = this.$route.params.filename;
			let loaded = window.localStorage.getItem(file);
			if (loaded == null)
			{
				console.error("not loaded")
				this.$router.push('/');
				return;
			}
			
			let parsed = JSON.parse(loaded);
			if (parsed == null || !parsed.initialized)
			{
				console.error("failed to parse")
				this.$router.push('/');
				return;
			}
			if (parsed.sections == undefined)
			{
				parsed.sections = [];
			}
			if (parsed.course_instructor == undefined)
			{
				parsed.course_instructor = "";
			}
			if (parsed.start_time == undefined)
			{
				parsed.start_time = ""
			}
			if (parsed.end_time == undefined)
			{
				parsed.end_time = ""
			}
			if (parsed.course_tas == undefined)
			{
				parsed.course_tas = ""
			}
			this.load_syllabus_data(parsed);
		},
		save(){
			localStorage.setItem(this.active_syllabus.file_name, JSON.stringify(this.active_syllabus))
		},
		updatePreview(){
			this.$refs.pdf_preview.innerHTML = this.srcHTML;
		},
		downloadDocx(){
			var converted = htmlDocx.asBlob(this.srcHTML);
			saveAs(converted, "syllabus.docx")
		},
		downloadSyl(){
			let json = JSON.stringify(this.active_syllabus);
			let blob = new Blob([json], {type: "application/json"});
			saveAs(blob, "syllabus.syl")
		}
	},
	mounted(){
		this.load();
		this.updatePreview();
	}
}
</script>

<style lang="scss" scoped>
.pdfobject-container {
	height: 30rem; border: 1rem solid rgba(0,0,0,.1);
}
.pdf-container {
	height: 50vh;
	overflow-y: auto;
	background-color: white;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
}
#pdf_preview{
	margin: 1in;
	color: black;
}
</style>
